import React, { useEffect, useState, useContext } from 'react';
import { FaCheck } from 'react-icons/fa6';
import Spinner from 'react-bootstrap/Spinner';
import { ForwardFittingContext } from '../ForwardFittingContext';
import { updateBallData } from '../../../Api/contact';
import Loader2 from '../../DashboardComponents/Loader/Loader2';
import { getCurrentUser } from "../../../Api/auth.js";

const BallData = ({ remoteData, projectid }) => {
  const [activeTab, setActiveTab] = useState('link');
  const [inputValue, setInputValue] = useState('');
  const [file, setFile] = useState(null);
  const [filename, setFilename] = useState('');
  const [loading, setLoading] = useState(false);
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [checkValidity, setCheckValidity] = useState(false);
  const { remotefittingdata, setRemotefittingdata } = useContext(ForwardFittingContext);

  useEffect(() => {
    if (remoteData.balldata) {
      const { value: data, type } = remoteData.balldata;
      if (type === 'link') {
        setInputValue(data);
        setFilename('');
        setActiveTab('link');
      } else {
        setFilename(data);
        setActiveTab('file');
        setInputValue('');
      }
    }
  }, [remoteData]);

  const handleUrlChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setIsValidUrl(validateUrl(value));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFilename(selectedFile ? selectedFile.name : '');
  };

  const saveAttachment = async (value, type) => {
    setLoading(true);
    const formData = new FormData();
    if (type === 'file' && file) {

      formData.append('image', file);
    }
    if (type == "file" && (file == null || filename == "")) {
      setCheckValidity(true);

    }
    formData.append('remoteFittingQueriesId', projectid);
    formData.append('value', value);
    formData.append('type', type);

    try {
      const res = await updateBallData(formData);
      setLoading(false);
      if (res.data.status) {
        const data = res.data.data.remotefittingdata;
        setRemotefittingdata(data);
      } else {
        alert(res.data.data[0]?.detail);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const validateUrl = (url) => {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' +
      '((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-zA-Z\\d%@_.~+&:]*)*' +
      '(\\?[;&a-zA-Z\\d%@_.,~+&:=-]*)?' +
      '(\\#[-a-zA-Z\\d_]*)?', 'i'
    );
    return !!urlPattern.test(url);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };


  const [role_id, seRole_id] = useState(null);

  useEffect(() => {
    const getCurrentUserdata = getCurrentUser();
    // setUserdata(getCurrentUserdata.user);
    // setUser_id(getCurrentUserdata.user._id);


    if (getCurrentUserdata && getCurrentUserdata.user) {
      seRole_id(getCurrentUserdata.user.role_id);
    } else {
      console.error("Current user data is null or undefined");
    }

  }, []);


  return (
    <>
      {loading && <Loader2 />}
      <div className="row black_bg_box cf mx-3"
        style={{
          borderRadius: '40px',
          backgroundColor: '#1e2025',
          pointerEvents: (remoteData?.irondata?.status == false || remoteData?.balldata?.status == true) ? 'none' : 'auto'
        }}>
        <div className="club-fitting-card new-m">
          <div className="gab_title m-0">
            <div className="collapsed d-flex align-items-center">
              <div className="gab_icon" style={{
                backgroundColor: remoteData.balldata.status ? "#99ea24" : "",
              }}>
                <FaCheck />
              </div>
              <div className="gab_text ms-3"><h5 className='cf-title'>Ball Data</h5></div>
            </div>
          </div>
          {
            role_id == 4 && (
              <div className='gab_text mb-4' style={{ fontSize: '20px' }}>
                Once you have finished your session we need you to export it or provide us a link to view your iron testing ball data.
              </div>
            )
          }
          {/* <div className='gab_text' style={{ fontSize: '20px' }}>
            Once you have finished your session we need you to export it or provide us a link to view your iron testing ball data.
          </div> */}
        </div>
        <div>
          <div className="tab-container cf-tabs m-0">
            <button
              className={`tab ${activeTab === 'link' ? 'active' : ''}`}
              onClick={() => setActiveTab('link')}
            >
              Link
            </button>
            <button
              className={`tab ${activeTab === 'file' ? 'active' : ''}`}
              onClick={() => setActiveTab('file')}
            >
              File
            </button>
          </div>
        </div>

        {activeTab === 'link' && (
          <div className="custom-input-container col-12 mt-4">
            <input
              type="url"
              value={inputValue}
              onChange={handleUrlChange}
              placeholder="Paste your link here..."
              className="custom-input col-12"
              style={{ border: inputValue === "" && !isValidUrl ? "2px solid red" : "none", marginBottom: '20px' }}
            />
            {!isValidUrl && inputValue !== "" && <p style={{ color: 'red' }}>Please enter a valid URL.</p>}

            <div className='save-attach d-flex align-items-center justify-content-between mt-4 mb-4 col-12'>
              <button
                className='btn save-attach-btn col-12 py-4'
                style={{ backgroundColor: '#99EA24' }}
                disabled={!isValidUrl || inputValue === "" || remoteData.balldata.status}
                onClick={() => saveAttachment(inputValue, "link")}
              >
                {loading ? <Spinner animation="border" className="border-black" /> : <span>Save Attachment</span>}
              </button>
            </div>
          </div>
        )}

        {activeTab === 'file' && (
          <div className="custom-input-container col-12 mt-4">
            <input
              type="file"
              onChange={handleFileChange}
              className="custom-input col-12"
              style={{ border: checkValidity ? "2px solid red" : "none" }}
            />
            {filename && <div style={{ color: "#99ea24" }}><strong>Selected File:</strong> {filename}</div>}

            <div className='save-attach d-flex align-items-center justify-content-between mt-4 mb-4 col-12'>
              <button
                className='btn save-attach-btn col-12 py-4'
                style={{ backgroundColor: '#99EA24' }}
                disabled={!file && filename === "" || remoteData.balldata.status}
                onClick={() => saveAttachment(filename, "file")}
              >
                {loading ? <Spinner animation="border" className="border-black" /> : <span>Save Attachment</span>}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BallData;
